// extracted by mini-css-extract-plugin
export default {"InformationPage":"InformationPage_InformationPage__afPSN"};